import type { GalleryImage } from './gallery'

export const lyleMediaRoot = '/media/lyle'
export const lylePhotoDir = `${lyleMediaRoot}/photos`
export const lyleVideoDir = `${lyleMediaRoot}/videos`

export interface BeforeAfterPair {
  before: string
  after: string
  beforeAlt: string
  afterAlt: string
  caption: string
}

export interface LyleVideo {
  src: string
  poster: string
  alt: string
}

/**
 * Add files from public/media/lyle here after upload.
 * Gallery concatenates these ahead of the current studio set.
 */
export const lyleUploadedPhotos: GalleryImage[] = []

export const lyleUploadedVideos: LyleVideo[] = []

export const paintCorrectionBeforeAfter: BeforeAfterPair[] = [
  {
    before: '/images/paint-correction.jpg',
    after: '/images/page-assets/booking-paint-correction.jpg',
    beforeAlt: 'Vehicle paint with visible swirl marks before correction.',
    afterAlt: 'Vehicle panel during professional paint correction in the Autoglow studio.',
    caption: 'Replace these placeholders with Lyle’s before and after pairs in public/media/lyle/photos.',
  },
]
